import type { ReactNode } from "react";
import type { IconName } from "../Icon";

export const baseStyle = `
  display: flex;
  align-items: center;
  border: none;
  border-radius: 8px;
  gap: 4px;
  &:focus {
    outline: none;
  }
  &:focus-visible {
    outline: 2px solid var(--control-bg);
    outline-offset: 2px;
  }
  &:hover:not(:disabled) {
    cursor: pointer;
  }
  &:disabled {
    opacity: 0.4;
    cursor: default;
  }
  &.m {
    padding: 4px 8px;
    height: 24px;
  }
  &.l {
    padding: 8px 12px;
    height: 32px;
  }
  &.icon-only.m {
    width: 24px;
    justify-content: center;
  }
  &.icon-only.l {
    width: 32px;
    justify-content: center;
  }
  &.primary {
    background: var(--control-bg);
    color: var(--control-fg);
    &:hover:not(:disabled) {
      opacity: 0.8;
    }
  }
  &.secondary {
    background: transparent;
    color: var(--text-primary);
    &:hover:not(:disabled) {
      background: var(--alpha4);
    }
    &:active:not(:disabled) {
      background: var(--alpha8);
    }
  }
  &.subtle {
    background: var(--alpha4);
    color: var(--text-primary);
    &:hover:not(:disabled) {
      background: var(--alpha8);
    }
  }
  &.danger {
    background: var(--red-600);
    color: white;
    &:hover:not(:disabled) {
      opacity: 0.8;
    }
  }
`;

export interface ButtonStyle {
  variant?: "primary" | "secondary" | "danger" | "subtle";
  size?: "m" | "l";
  icon?: IconName;
  children?: ReactNode;
  className?: string;
}

export function buttonClass({
  variant = "primary",
  size = "m",
  icon,
  children,
  className,
}: ButtonStyle) {
  const iconOnly = icon && !children;
  return [className, variant, size, iconOnly && "icon-only"]
    .filter(Boolean)
    .join(" ");
}
